import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router';
import { LocalStorage } from '@/constants';
import { getAuthToken } from '@/utils/auth-token';

const TICKET_ORIGIN = 'U2FsdGVkX19M063HBhAodQj5ouYrNfl5vNVK2z2jvts%3D';

export const AuthGate = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const origin = searchParams.get('origin');
  const token = getAuthToken();

  if (!token) {

    if (origin === 'ticket_vantagens') {
      localStorage.setItem(LocalStorage.RedirectAfterLogin, location.pathname);
      return (
        <Navigate
          to={`/login/novos_registros?origin=${TICKET_ORIGIN}`}
          replace
        />
      );
    }

    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
